import DocumentsMd from './view'

export default DocumentsMd
